var React = require('react');

function BtnBackwardInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Homescreen","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round"},React.createElement("g",{"id":"Homescreen-Desktop-Copy-2","transform":"translate(-189.000000, -282.000000)","stroke":"#FFFFFF","strokeWidth":"3.84"},React.createElement("g",{"id":"btnForward-Copy","transform":"translate(211.500000, 317.000000) scale(-1, 1) translate(-211.500000, -317.000000) translate(200.000000, 293.000000)"},React.createElement("g",{"id":"scroll-horizontal"},React.createElement("path",{"d":"M-3.24007488e-14,0 L21,21 C22.6561039,22.657165 22.6561039,25.342835 21,27 L-3.24007488e-14,48","id":"Shape"}))))));
}

BtnBackwardInline.defaultProps = {"className":"assets-btn-backward","width":"45px","height":"70px","viewBox":"0 0 45 70","version":"1.1"};

module.exports = BtnBackwardInline;

BtnBackwardInline.default = BtnBackwardInline;
